export default __webpack_public_path__ + "static/media/bell-regular.415181b7.svg";